import React, { Component } from "react";
import { Modal, Form, Row, Col, FormGroup, Button } from "react-bootstrap";

import { withRouter } from "react-router-dom";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";

class UserModal extends Component {
  constructor(props) {
    super(props);
    console.log("constructor", this.props);
    this.state = {
      currentStep: 1,
      branch: "",
      principle: "",
      mobile: "",
      address: "",
      region: "",
      submitError: "",
      formErrors: {
        branch: "",
        principle: "",
        mobile: ""
      },
      branchValid: false,
      principleValid: false,
      mobileValid: false,
      formValid: false
    };
  }

  render() {
    console.log("UserModal", this.props);
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '18px 22px', background: '#fff', borderBottom: '1px solid #f1f5f9' }}>
          <div style={{ width: 40, height: 40, borderRadius: 11, background: '#f5f3ff', border: '1px solid #ddd6fe', color: '#7c3aed', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 }}>
            <i className="fal fa-code-branch" />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h5 style={{ fontWeight: 800, fontSize: 17, color: '#0f172a', margin: 0, lineHeight: 1.2 }}>Add New Branch</h5>
            <span style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Create a new institute branch</span>
          </div>
          <button type="button" style={{ marginLeft: 'auto', background: 'transparent', border: 'none', color: '#94a3b8', fontSize: 24, cursor: 'pointer', lineHeight: 1, padding: 0 }} onClick={this.props.onHide} aria-label="Close">×</button>
        </div>
        <Modal.Body className="p-4">
          {this.props.stateData.currentStep == 5 ? (
            <Form.Text className="form-text text-success">
              Branch Saved successfully
            </Form.Text>
          ) : (
              <Form.Text className="form-text text-danger">
                {this.props.stateData.submitError}
              </Form.Text>
            )}
          <Form>
            <Row>
              <Col lg={8} md={12} sm={12}>
                <Form.Row>
                  <Form.Group
                    as={Col}
                    lg={6}
                    md={12}
                    sm={12}
                    controlId="SelectBranch"
                  >
                    <Form.Label className="text-uppercase">
                      Branch Name<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Branch Name"
                      onChange={this.props.ParenthandleInputChange}
                      autoComplete="off"
                      name="branch"
                      value={this.props.stateData.branch}
                      maxLength={100}
                    />
                    <Form.Text className="form-text text-danger">
                      {this.props.stateData.formErrors.branch}
                    </Form.Text>
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    lg={6}
                    md={12}
                    sm={12}
                    controlId="SelectContact"
                  >
                    <Form.Label className="text-uppercase">
                      Contact No<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      inputMode="numeric"
                      placeholder="Mobile No"
                      name="mobile"
                      onChange={this.props.ParenthandleInputChange}
                      autoComplete="off"
                      value={this.props.stateData.mobile}
                      maxLength={10}
                    />
                    <Form.Text className="form-text text-danger">
                      {this.props.stateData.formErrors.mobile}
                    </Form.Text>
                  </Form.Group>
                </Form.Row>
                <Form.Group controlId="SelectAddress" className="my-4">
                  <Form.Label className="text-uppercase">
                    Complete Address
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Address"
                    name="address"
                    onChange={this.props.ParenthandleInputChange}
                    autoComplete="off"
                    value={this.props.stateData.address}
                    maxLength={250}
                  />
                </Form.Group>
                <Form.Row>
                  <Form.Group
                    as={Col}
                    lg={6}
                    md={12}
                    sm={12}
                    controlId="SelectState"
                  >
                    <Form.Label className="text-uppercase">State<span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="region"
                      onChange={this.props.ParenthandleInputChange}
                      value={this.props.stateData.region}
                    >
                      <option value="">--Select State--</option>
                      {this.props.globals.regions.map(regionsdata => (
                        <option value={regionsdata.id} key={regionsdata.id}>
                          {regionsdata.region}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Text className="form-text text-danger">
                      {this.props.stateData.formErrors.region}
                    </Form.Text>
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    lg={6}
                    md={12}
                    sm={12}
                    controlId="SelectCity"
                  >
                    <Form.Label className="text-uppercase">City<span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="city_id"
                      onChange={this.props.ParenthandleInputChange}
                      value={this.props.stateData.city_id}
                    >
                      <option value="">--Select City--</option>
                      {this.props.globals.cities.map(citiesdata => {
                        if (this.props.stateData.region > 0) {
                          if (
                            this.props.stateData.region == citiesdata.region_id
                          )
                            return (
                              <option value={citiesdata.id} key={citiesdata.id}>
                                {citiesdata.city_name}
                              </option>
                            );
                          else return null;
                        } else {
                          return (
                            <option value={citiesdata.id} key={citiesdata.id}>
                              {citiesdata.city_name}
                            </option>
                          );
                        }
                      })}
                    </Form.Control>
                    <Form.Text className="form-text text-danger">
                      {this.props.stateData.formErrors.city_id}
                    </Form.Text>
                  </Form.Group>
                </Form.Row>
              </Col>
              <Col lg={4} md={12} sm={12} className="border-left">
                <Form.Group controlId="InputAddress">
                  <Form.Label className="text-uppercase">HOD</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    name="hod"
                    onChange={this.props.ParenthandleInputChange}
                    autoComplete="off"
                    value={this.props.stateData.hod}
                    maxLength={100}
                  />
                </Form.Group>
                <Form.Group controlId="InputPhone1">
                  <Form.Control
                    type="text"
                      inputMode="numeric"
                    placeholder="Mobile No"
                    name="hod_mobile"
                    onChange={this.props.ParenthandleInputChange}
                    autoComplete="off"
                    value={this.props.stateData.hod_mobile}
                    maxLength={10}
                  />
                  <Form.Text className="form-text text-danger">
                    {this.props.stateData.formErrors.hod_mobile}
                  </Form.Text>
                </Form.Group>
                <Form.Group controlId="InputPriciple">
                  <Form.Label className="text-uppercase">principal<span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    name="principal"
                    onChange={this.props.ParenthandleInputChange}
                    autoComplete="off"
                    value={this.props.stateData.principal}
                    maxLength={100}
                  />
                </Form.Group>
                <Form.Group controlId="InputPhone2">
                  <Form.Control
                    type="text"
                      inputMode="numeric"
                    placeholder="Mobile No"
                    name="principal_mobile"
                    onChange={this.props.ParenthandleInputChange}
                    autoComplete="off"
                    value={this.props.stateData.principal_mobile}
                    maxLength={10}
                  />
                  <Form.Text className="form-text text-danger">
                    {this.props.stateData.formErrors.principal_mobile}
                  </Form.Text>
                </Form.Group>
                <Form.Group controlId="InputVicePriciple">
                  <Form.Label className="text-uppercase">
                    Vice principal
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    name="vice_principal"
                    onChange={this.props.ParenthandleInputChange}
                    autoComplete="off"
                    value={this.props.stateData.vice_principal}
                    maxLength={100}
                  />
                </Form.Group>
                <Form.Group controlId="InputPhone3">
                  <Form.Control
                    type="text"
                      inputMode="numeric"
                    placeholder="Mobile No"
                    name="vice_principal_mobile"
                    onChange={this.props.ParenthandleInputChange}
                    autoComplete="off"
                    value={this.props.stateData.vice_principal_mobile}
                    maxLength={10}
                  />
                  <Form.Text className="form-text text-danger">
                    {this.props.stateData.formErrors.vice_principal_mobile}
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer variant="white" className="px-4">
          <Button
            className="text-uppercase px-5"
            style={{ background: '#7c3aed', borderColor: '#7c3aed', color: '#fff' }}
            onClick={this.props.ParenthandleFormSubmitInsert}
            disabled={this.props.stateData.isAddSaving}
          >
            {this.props.stateData.isAddSaving ? (
              <>
                <span className="spinner-border spinner-border-sm" style={{ marginRight: 6 }}></span> Saving...
              </>
            ) : (
              "Save Branch"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default UserModal;
